import { render, staticRenderFns } from "./XmlText.vue?vue&type=template&id=31ad3ae3&scoped=true&"
import script from "./XmlText.vue?vue&type=script&lang=js&"
export * from "./XmlText.vue?vue&type=script&lang=js&"
import style0 from "./XmlText.vue?vue&type=style&index=0&id=31ad3ae3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad3ae3",
  null
  
)

export default component.exports